import { getOffsetTop } from './get-offset-top';
import { isScreenLarge } from './screen-size';

type ScrollFilterByProps = {
  target: HTMLElement;
  scr: {
    lg: number;
    sm: number;
  };
  behavior?: ScrollToOptions['behavior'];
};

export const scrollFilterBy = ({
  target,
  scr,
  behavior,
}: ScrollFilterByProps): void => {
  const targetY = target ? getOffsetTop(target) : 0;
  const siteHeader = document.querySelector('header');
  const siteFilter = document.querySelector('.filter-mobile .body');

  // @ts-ignore
  const siteFilterH = siteFilter?.offsetHeight || 0;

  // @ts-ignore
  const siteHeaderH = siteHeader?.offsetHeight || 0;
  const scrollLG = targetY - siteHeaderH - scr.lg;
  const scrollSM = targetY - siteFilterH - scr.sm;
  const scrollTop = isScreenLarge() ? scrollLG : scrollSM;
  window.scrollTo({ top: scrollTop, left: 0, behavior: behavior || 'smooth' });
};
